<template>
    <div v-if="estudioSocio" class="row q-col-gutter-md">
        <div class="col-12 text-h6 text-primary no-grap row">
            <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
            Estudio Socioeconomico
            <q-space />
            <q-btn flat round color="primary" icon="print" @click="exportarPDF()" />
        </div>
        <div class="col-12">
            <q-separator class="bg-primary" />
        </div>
        <div class="col-12">
            <q-input filled dense v-model="paciente.nombres" label="Nombre(s)" />
        </div>
        <div class="col-12">
            <q-input filled dense v-model="paciente.apellidoPaterno" label="Apellido Paterno" />
        </div>
        <div class="col-12">
            <q-input filled dense v-model="paciente.apellidoMaterno" label="Apellido Materno" />
        </div>
        <div class="col-4">
            <q-field filled dense label="Fecha de Nacimiento" stack-label>
                <template v-slot:control>
                    <div class="self-center full-width no-outline" tabindex="0">
                        {{ formatearFecha(paciente.fechaNacimiento) }}
                    </div>
                </template>
            </q-field>
            <!-- <q-input v-model="paciente.fechaNacimiento" filled dense label="Fecha de Nacimiento" /> -->
        </div>
        <div class="col-4">
            <q-input filled dense v-model="estudioSocio.sexo" label="Sexo" />
        </div>
        <div class="col-4">
            <q-input filled dense v-model="estudioSocio.estadoCivil" label="Estado Civil" />
        </div>
        <div class="col-12">
            <q-input filled dense v-model="estudioSocio.escolaridad" label="Escolaridad" />
        </div>
        <div class="col-6">
            <q-input filled dense v-model="estudioSocio.ocupacion" label="Ocupación" />
        </div>
        <div class="col-6">
            <q-input filled dense v-model="estudioSocio.religion" label="Religión" />
        </div>
        <div class="col-12">
            <q-input filled dense v-model="estudioSocio.originario" label="Originario" />
        </div>
        <div class="col-12">
            <q-input filled dense v-model="estudioSocio.derechohabiente" label="Derechohabiente" />
        </div>
        <div class="col-12">
            <q-input filled dense v-model="estudioSocio.domicilioPermanente" label="Domicilio Permanente" />
        </div>
        <div class="col-12">
            <q-input filled dense v-model="estudioSocio.domicilioTemporal" label="Domicilio Temporal" />
        </div>
        <div class="col-12">
            <q-input filled dense v-model="estudioSocio.nombreFamiliarResponsable"
                label="Nombre Familiar o Responsable" />
        </div>
        <div class="col-12">
            <q-input filled dense v-model="estudioSocio.domicilioResponsable" label="Domicilio del Responsable" />
        </div>
        <div class="col-12">
            <q-input filled dense v-model="estudioSocio.diagnosticoMedico" label="Diagnóstico Médico" />
        </div>
        <div class="col-6">
            <q-table flat title="Grupo Familiar" bordered hide-bottom :rows="grupoFamiliar"
                :columns="columnsGrupoFamiliar" row-key="name" separator="vertical" />
        </div>
        <div class="col-6">
            <q-table flat title="Ocupacion" bordered hide-bottom :rows="grupoFamiliar" :columns="columnsGrupoFamiliar"
                row-key="name" separator="vertical" />
        </div>
        <div class="col-12 text-h6 text-primary">
            <q-icon name="mdi-file-document-edit" color="primary" size="22px" class="q-mr-sm" />
            SISTEMA DE CUOTAS DE RECUPERACIÓN (NIVEL NACIONAL)
        </div>
        <div class="col-12">
            <q-separator class="bg-primary" />
        </div>
        <div class="col-6">
            <q-table flat title="Ingreso Familiar (Promedio Mensual)" bordered hide-bottom :rows="grupoFamiliar"
                :columns="columnsGrupoFamiliar" row-key="name" separator="vertical" />
        </div>
        <div class="col-6">
            <q-table flat title="Egreso Familiar (Promedio Mensual)" bordered hide-bottom :rows="grupoFamiliar"
                :columns="columnsGrupoFamiliar" row-key="name" separator="vertical" />
        </div>
        <div class="col-6">
            <q-table flat title="Salario" bordered hide-bottom :rows="grupoFamiliar" :columns="columnsGrupoFamiliar"
                row-key="name" separator="vertical" />
        </div>
        <div class="col-6">
            <q-table flat title="Situación Económica" bordered hide-bottom :rows="grupoFamiliar"
                :columns="columnsGrupoFamiliar" row-key="name" separator="vertical" />
        </div>
        <div class="col-6">
            <q-table flat title="Vivienda" bordered hide-bottom :rows="grupoFamiliar" :columns="columnsGrupoFamiliar"
                row-key="name" separator="vertical" />
        </div>
        <div class="col-6">
            <q-table flat title="Dormitorios" bordered hide-bottom :rows="grupoFamiliar" :columns="columnsGrupoFamiliar"
                row-key="name" separator="vertical" />
        </div>
        <div class="col-12">
            <q-input filled dense label="Diagnóstico Social" />
        </div>
        <div class="col-6">
            <q-table flat title="Calificaciones" bordered hide-bottom :rows="grupoFamiliar"
                :columns="columnsGrupoFamiliar" row-key="name" :separator="separator" />
        </div>
        <div class="col-6">
            <q-table flat title="Escala de calificaciones" bordered hide-bottom :rows="grupoFamiliar"
                :columns="columnsGrupoFamiliar" row-key="name" :separator="separator" />
        </div>
    </div>

</template>
<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import { computed, onBeforeMount } from "vue";
import axios from "axios";
import { generarFichaSocioeconomica } from '../PDF/EstudioSocioeconomicoPDF.js'
import { Notify, useQuasar, QSpinnerFacebook } from "quasar";
import Paciente from "../Pacientes/Paciente.vue";
const $q = useQuasar();
const store = useStore();

const grupoFamiliar = ref([]);
const paciente = computed({
    get: () => store.state.pacienteStore,
    set: (val) => (store.state.pacienteStore = val),
});

const estudioSocio = ref(null)

const showEdit = computed(() => {
    return !!store.state.pacienteStore?.id;
});

onBeforeMount(() => {
    getEstudioSocioEconomico();
})
function formatearFecha(fecha) {
    return new Intl.DateTimeFormat('es-MX', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    }).format(new Date(fecha))
}

const columnsGrupoFamiliar = [
    { name: 'grupoFamiliar', align: 'left', label: 'Grupo Familiar', field: 'grupoFamiliar', sortable: true },
    { name: 'calif', align: 'center', label: 'Calificación', field: 'calif', sortable: true },
]

const getEstudioSocioEconomico = async () => {
    $q.loading.show({
        spinner: QSpinnerFacebook,
        spinnerColor: 'primary',
        spinnerSize: 100,
        message: 'Consultando estudio socioeconomico...'
    })
    try {
        const response = await axios.get('EstudioSocioEconomico/Paciente/' + paciente.value.id)
        console.log('Respuesta backend:', response.data)
        estudioSocio.value = response.data[0]
    } catch (error) {
        console.error(error)
        Notify.create({
            message: 'Error al consultar la información',
            color: 'negative',
            position: 'top-right'
        })
    } finally {
        $q.loading.hide()
    }
}

async function exportarPDF() {
    await generarFichaSocioeconomica(paciente.value, estudioSocio.value)
}
</script>
